import styled from "styled-components"

const Container = styled.div`
    margin: 1rem 2rem;
`

export default Container
